export default __webpack_public_path__ + "static/media/sbm-logo.bc2a0b74.png";